function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// -------------------------------------
// Dependencies
// -------------------------------------
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import { formatMoney } from '@shopify/theme-currency';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Selling Plan Extension
// -------------------------------------
iamotaEventHandler.subscribe('productForm:init', _ref => {
  var {
    iamForm
  } = _ref;
  var iamProductForm = iamForm;

  // Instance-scoped properties
  iamProductForm.sellingPlanGroups = [];
  iamProductForm.selectedPlan = null;
  iamProductForm.translations.sellingPlans = {
    purchase_options: translate('Purchase Options', 'sellingplan.purchase_options'),
    onetime: translate('One-time Purchase', 'sellingplan.group_label.onetime'),
    error: translate('Subscription options unavailable', 'sellingplan.error'),
    tooltip: translate('Subscribe to this product and have it conveniently delivered to you at the frequency you choose! Promotion subject to change.', 'sellingplan.tooltip')
  };
  iamotaEventHandler.watchDOM('[name="selling_plan"]', (el, type, evt) => {
    if (type === 'input-change') {
      var _evt$target;
      Debug.extreme('Selling plan edited:', evt === null || evt === void 0 || (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.value);
    } else if (type === 'changed') {
      Debug.extreme('Selling plan silent change:', el);
    } else if (type === 'added') {
      Debug.extreme('Selling plan added:', el);
    } else if (type === 'removed') {
      Debug.extreme('Selling plan removed');
    } else {
      Debug.warn('Unhandled event type:', type, 'for element:', el);
    }
    var sellingPlan = iamProductForm.getCurrentSellingPlan();
    iamotaEventHandler.trigger('productForm:sellingPlan:changed', {
      sellingPlan
    }, {
      context: iamProductForm
    });
  }, {
    context: iamProductForm,
    watchInputChanges: true
  });
  iamProductForm.getCurrentSellingPlan = function () {
    var elem = iamProductForm.querySelector('[name="selling_plan"]');
    var selectedPlanId = (elem === null || elem === void 0 ? void 0 : elem.value) || null;
    var sellingPlan = this.sellingPlanGroups.flatMap(group => group.plans).find(plan => plan.id == selectedPlanId);
    this.selectedPlan = sellingPlan;
    // Debug.extreme('Selected Selling Plan:', this.selectedPlan);

    return this.selectedPlan;
  };
  iamProductForm.refreshSellingPlans = function () {
    this.setLoading(true);
    try {
      this.sellingPlanGroups = this.preprocessSellingPlans();
      this.selectedPlan = this.getCurrentSellingPlan();
    } catch (error) {
      console.error('Selling Plan Processing Error:', error);
      this.setErrorState(this.translations.sellingPlans.error);
    } finally {
      this.setLoading(false);
    }
  };
  iamProductForm.preprocessSellingPlans = function () {
    var _product$selling_plan;
    var variant = this.getCurrentVariant();
    var product = this.getCurrentProduct();
    var groups = [];
    product === null || product === void 0 || (_product$selling_plan = product.selling_plan_groups) === null || _product$selling_plan === void 0 || _product$selling_plan.forEach(group => {
      var _group$selling_plans$;
      var discounts = group.selling_plans.map(plan => {
        var _plan$price_adjustmen;
        var adj = plan === null || plan === void 0 || (_plan$price_adjustmen = plan.price_adjustments) === null || _plan$price_adjustmen === void 0 ? void 0 : _plan$price_adjustmen[0];
        if (!adj) return 'none:none';
        return "".concat(adj.value_type, ":").concat(adj.value);
      });
      var uniqueDiscounts = [...new Set(discounts)];
      var commonDiscountAdj = uniqueDiscounts.length === 1 ? (_group$selling_plans$ = group.selling_plans[0]) === null || _group$selling_plans$ === void 0 || (_group$selling_plans$ = _group$selling_plans$.price_adjustments) === null || _group$selling_plans$ === void 0 ? void 0 : _group$selling_plans$[0] : null;
      var nameWithDiscount = translate('{{ name }} {{ common_discount }}', 'sellingplan.group_label.sellingplan', _objectSpread(_objectSpread({}, group), {}, {
        common_discount: this.formatDiscountLabel(commonDiscountAdj)
      }));
      var plans = group.selling_plans.map(plan => {
        var _variant$selling_plan, _plan$price_adjustmen2, _plan$price_adjustmen3, _plan$options;
        var allocation = variant === null || variant === void 0 || (_variant$selling_plan = variant.selling_plan_allocations) === null || _variant$selling_plan === void 0 ? void 0 : _variant$selling_plan.find(a => a.selling_plan_id === plan.id);
        var adj = (_plan$price_adjustmen2 = plan === null || plan === void 0 || (_plan$price_adjustmen3 = plan.price_adjustments) === null || _plan$price_adjustmen3 === void 0 ? void 0 : _plan$price_adjustmen3[0]) !== null && _plan$price_adjustmen2 !== void 0 ? _plan$price_adjustmen2 : null;
        var purchaseType = plan.recurring_deliveries ? 'subscription' : 'selling_plan';
        var opt0 = plan === null || plan === void 0 || (_plan$options = plan.options) === null || _plan$options === void 0 ? void 0 : _plan$options[0];
        var rawLabel = opt0 ? "".concat(opt0.name, " ").concat(opt0.value) : plan.name || group.name || '';
        var formattedDiscount = this.formatDiscountLabel(adj);
        return {
          id: plan.id,
          purchase_type: purchaseType,
          group_id: group.id,
          group_name: group.name,
          group_name_with_discount: nameWithDiscount,
          optionMapping: opt0 ? {
            [opt0.name]: opt0.value
          } : {},
          label: rawLabel,
          label_with_discount: translate('{{ label }} (Save {{ formatted_discount }})', 'sellingplan.plan_label', _objectSpread(_objectSpread({}, plan), {}, {
            label: rawLabel,
            formatted_discount: formattedDiscount
          })),
          formatted_discount: formattedDiscount,
          name: plan.name || group.name,
          description: plan.description,
          discount: adj ? {
            value_type: adj.value_type,
            value: adj.value,
            name: formattedDiscount
          } : null,
          price: formatMoney(allocation === null || allocation === void 0 ? void 0 : allocation.price) || formatMoney(variant === null || variant === void 0 ? void 0 : variant.price),
          compare_at_price: formatMoney(allocation === null || allocation === void 0 ? void 0 : allocation.compare_at_price) || formatMoney(variant === null || variant === void 0 ? void 0 : variant.compare_at_price),
          per_delivery_price: (allocation === null || allocation === void 0 ? void 0 : allocation.per_delivery_price) || (allocation === null || allocation === void 0 ? void 0 : allocation.price) || (variant === null || variant === void 0 ? void 0 : variant.price),
          recurring_deliveries: plan.recurring_deliveries,
          tooltip: this.translations.sellingPlans.tooltip
        };
      });
      groups.push({
        id: group.id,
        name: group.name,
        name_with_discount: nameWithDiscount,
        options: group.options,
        plans: plans
      });
    });
    if (!(product !== null && product !== void 0 && product.requires_selling_plan)) {
      groups.push({
        id: 'onetime',
        name: this.translations.sellingPlans.onetime,
        name_with_discount: this.translations.sellingPlans.onetime,
        options: [],
        plans: [this.createOnetimePlan(variant)]
      });
    }
    Debug.extreme('Processed Selling Plan Groups:', groups);
    return groups;
  };
  iamProductForm.createOnetimePlan = function (variant) {
    return {
      id: null,
      purchase_type: 'onetime',
      group_id: 'onetime',
      group_name: this.translations.sellingPlans.onetime,
      group_name_with_discount: this.translations.sellingPlans.onetime,
      optionMapping: {},
      label: this.translations.sellingPlans.onetime,
      label_with_discount: this.translations.sellingPlans.onetime,
      name: this.translations.sellingPlans.onetime,
      description: null,
      discount: null,
      price: formatMoney(variant.price),
      compare_at_price: formatMoney(variant.compare_at_price),
      per_delivery_price: variant.price,
      recurring_deliveries: false
    };
  };
  iamProductForm.formatDiscountLabel = function (adj) {
    if (!adj) return '';
    if (adj.value_type === 'percentage') {
      return "".concat(adj.value, "%");
    }
    if (adj.value_type === 'fixed_amount') {
      return formatMoney(adj.value);
    }
    return adj.value;
  };

  // Run initial refresh now that it's attached
  iamProductForm.refreshSellingPlans();
}, {
  priority: 90,
  source: "product-form--selling-plans.js"
});
iamotaEventHandler.subscribe('productForm:variant:changed', _ref2 => {
  var {
    iamProductForm
  } = _ref2;
  iamProductForm.refreshSellingPlans();
}, {
  source: "product-form--selling-plans.js"
});